// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"cd5285fd","278":"212d103c","768":"5767048e","781":"c227618f","962":"c4cc58d2"}[chunkId] + ".chunk.js";
};